import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, input } from '@angular/core';
import { ProcessDefinitionService } from '@core/engine-processes/services/process-definition-service';
import { EngineViewComponent } from '@core/engine-views/components/engine-view/engine-view.component';
import { ProcessStateDto } from '@core/services/api-clients';
import { Observable } from 'rxjs';
import { EngineProcessCurrentStateComponent } from '../engine-process-current-state/engine-process-current-state.component';

@Component({
  selector: 'engine-process-grid-cell',
  templateUrl: './engine-process-grid-cell.component.html',
  styleUrls: ['./engine-process-grid-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EngineProcessCurrentStateComponent, AsyncPipe],
})
export class EngineProcessGridCellComponent {
  private _processesService = inject(ProcessDefinitionService);
  private _engineView = inject(EngineViewComponent, { optional: true });

  private _stateId: string;

  @Input()
  set stateId(value: string) {
    this._stateId = value;
    if (value) {
      this._processesService.loadProcessStateWithTransitions(value);
      this.currentState$ = this._processesService.getProcessState(value);
    }
    else
    {
      this.currentState$ = null;
    }
  }

  readonly attributeName = input<string>(undefined);
  readonly recordId = input<string>(undefined);

  currentState$: Observable<ProcessStateDto> | null;

  get stateId(): string {
    return this._stateId;
  }

  constructor() {}

  executeTransition(event: { currentProcessState: ProcessStateDto; targetStateId: string }) {
    let columnAttribute = this._engineView.entityView.view.entity.attributes.find(
      (x) => x.name == this.attributeName().substring(0, this.attributeName().length - 2),
    );
    this._processesService
      .executeTransition(event.targetStateId, this.recordId(), columnAttribute.id)
      .subscribe(() => this._engineView.refreshData());
  }
}
